// extracted by mini-css-extract-plugin
export default {"filters":"fahrzeuge-der-car-policy-filters_filters__-W3cs"};